module.exports = __webpack_public_path__ + "img/1412.87445582.gif";